export const FLY_SPEED_WORLD_FACTOR = 1
export const FLY_SPEED_REFERENCE_SPAN = 8

export function effectiveFlySpeed(flySpeed: number, sceneSpanMeters: number): number {
  const span = Number.isFinite(sceneSpanMeters) && sceneSpanMeters > 0 ? sceneSpanMeters : FLY_SPEED_REFERENCE_SPAN
  return flySpeed * (span / FLY_SPEED_REFERENCE_SPAN) * FLY_SPEED_WORLD_FACTOR
}
